import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialTabs, SectionSubHeader } from 'components/layout'
import { ActivityProgress } from 'components/misc'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

export default class ActivitySubHeader extends Component {
  static propTypes = {
    isMajor: PropTypes.bool,
    completedPercentage: PropTypes.number,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    activityRoute: PropTypes.string,
    activitySection: PropTypes.string
  }

  static defaultProps = {
    isMajor: false,
    activityType: null,
    activitySection: null,
    completedPercentage: null
  }

  render() {
    const {
      isMajor,
      title,
      subtitle,
      activityRoute,
      activitySection,
      completedPercentage
    } = this.props

    return (
      <SectionSubHeader
        title={title}
        isMajor={isMajor}
        subtitle={subtitle}
        activitySection={activitySection}
        progress={
          <ActivityProgress white completedPercentage={completedPercentage} />
        }
        tabs={
          <MaterialTabs
            root={activityRoute}
            items={[
              {
                id: 0,
                label: 'Logs',
                intlKey: 'tabs.logs',
                to: 'logs'
              },
              {
                id: 1,
                label: 'Overview',
                intlKey: 'tabs.overview',
                to: 'overview'
              },
              {
                id: 2,
                label: 'Files',
                intlKey: 'tabs.files',
                to: 'files'
              },
              {
                id: 3,
                label: 'Badges',
                intlKey: 'tabs.badges',
                to: 'badges',
                configs: [CONFIGURATION_KEYS.isBadgesEnabled.id]
              }
            ]}
          />
        }
      />
    )
  }
}
